export const STUDIO_BASE_URL = 'https://studio.moonchild.ai';
export const VITE_FORGE_URL = import.meta.env.VITE_FORGE_URL.endsWith('/')
	? import.meta.env.VITE_FORGE_URL.slice(0, -1)
	: import.meta.env.VITE_FORGE_URL;

export const PRICING_URL = 'https://moonchild.ai/pricing';
export const SURVEY_URL = 'https://forms.gle/vwrB8ET8R91pvm1G8';
export const CHROME_EXTENSION_URL =
	'https://chromewebstore.google.com/detail/moonchild/gemkdajnghnanjoehknfbacbjnndfdph';
export const SUPPORT_EMAIL = 'hello@moonchild.ai';
export const CALENDLY_URL = 'https://calendly.com/d/ctsk-bc6-j8f/chat-with-lotanna';
export const STUDIO_VERSION = import.meta.env.VITE_STUDIO_VERSION || '0.0.0';
